export const PageNames = {
    accounts: 'accounts',
    baseRoute: 'baseRoute',
    connectionFailurePage: 'connectionFailurePage',
    eStatements: 'eStatements',
    forgotCredentialsPage: 'forgotCredentialsPage',
    landingPage: 'landingPage',
    loginPage: 'loginPage',
    pageNotFound: 'pageNotFound',
    planPage: 'planPage',
    profile: 'profile',
    profileAddress: 'profileAddress',
    profileEmail: 'profileEmail',
    profileLanguage: 'profileLanguage',
    profilePassword: 'profilePassword',
    profilePhone: 'profilePhone',
    registrationPage: 'registrationPage',
    sessionExpiredPage: 'sessionExpiredPage',
    transactionHistoryPage: 'transactionHistoryPage',
};

export const AppRoutes = {
    [PageNames.accounts]: 'routes.accounts',
    [PageNames.baseRoute]: 'routes.base',
    [PageNames.eStatements]: 'routes.eStatements',
    [PageNames.loginPage]: 'routes.login',
    [PageNames.landingPage]: 'routes.landing',
    [PageNames.registrationPage]: 'routes.registration',
    [PageNames.forgotCredentialsPage]: 'routes.forgot.credentials',
    [PageNames.connectionFailurePage]: 'routes.connection.failure',
    [PageNames.pageNotFound]: 'routes.page.not.found',
    [PageNames.planPage]: 'routes.accounts.plan.page',
    [PageNames.profile]: 'routes.profile',
    [PageNames.profileEmail]: 'routes.profile.email',
    [PageNames.profilePhone]: 'routes.profile.phone',
    [PageNames.profileAddress]: 'routes.profile.address',
    [PageNames.profileLanguage]: 'routes.profile.language',
    [PageNames.profilePassword]: 'routes.profile.password',
    [PageNames.transactionHistoryPage]: 'routes.accounts.plan.transaction.history',
    [PageNames.sessionExpiredPage]: 'routes.session.expired',
};
